<template>
    <v-layout row wrap class="mt-4">
        <v-flex v-for="(link, i) in content" :key="i" class="d-inline">
            <linkGreen class="mr-4" @click="link.database_id ? modal_open_wrapper(link.database_id) : 'null'">{{ link.title }}</linkGreen>
        </v-flex>
    </v-layout>
</template>

<script>
import linkGreen from '@/components/ui/links/styled/link_green.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    linkGreen,
  },
  props: {
    content: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters('database/modal', [
      'database_detail_modal',
      'current_detail',
    ]),
  },
  methods: {
  ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT',
    ]),
    modal_open_wrapper(database_id) {
      this.OPEN_MODAL(this.database_detail_modal);
      this.SET_CURRENT(database_id);
    },
  }
};
</script>
